<ion-searchbar placeholder="{{ 'static.search' | translate }}" (ionInput)="filterCards($event.target.value)"></ion-searchbar>
<ion-button *ngIf="hasCustomFilters" fill="clear" size="small" (click)="setCustomFilters()">
  <ion-icon [name]="filterIcon" size="large"></ion-icon>
</ion-button>
